import React, { Component } from "react";
import {
  Row,
  Label,
  Col,
  Modal,
  ModalBody,
  Button,
  Input,
  ModalHeader,
  Alert,
} from "reactstrap";
import { UserRole } from "../../../../utils/constants";
import axios from "../../../../axios";
import * as Url from "../../../../utils/url";
import { validatePassword } from "../../../../utils/validations";
import ErrorMessage from "../../../../components/Message/ErrorMessage/ErrorMessage";
// import Loading from '../../../../hoc/Loading/LoadingWithError';
import Loading from "../../../../hoc/Loading/Loading";

// import UserRobot1 from '../../../../assets/user-image-plc/User_Robot_1.svg';
import "../UserProfile.css";
import { isMobile } from "../../../../utils/deviceInfo";
import If from "../../../../components/Shared/If";

class LoginInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showEditLoginInfoModal: false,
      currentPassword: {
        value: "",
        error: false,
      },
      newPassword: {
        value: "",
        error: false,
      },
      confirmNewPassword: {
        value: "",
        error: false,
      },
      error: false,
      errorMessage: "",
    };
  }

  handleEditLoginInfo = () => {
    this.setState({ error: false });
    let { currentPassword, newPassword, confirmNewPassword } = this.state;
    if (currentPassword.value.trim() === "") {
      this.setState({
        currentPassword: {
          value: "",
          error: true,
          errorMessage: "Please enter current password",
        },
      });
    } else if (!validatePassword(currentPassword.value.trim())) {
      this.setState({
        currentPassword: {
          value: currentPassword.value,
          error: true,
          errorMessage: "Please enter valid current password",
        },
      });
    } else if (newPassword.value.trim() === "") {
      this.setState({
        newPassword: {
          value: "",
          error: true,
          errorMessage: "Please enter new password",
        },
      });
    } else if (!validatePassword(newPassword.value.trim())) {
      this.setState({
        newPassword: {
          value: newPassword.value,
          error: true,
          errorMessage: "Please enter a valid password.",
        },
      });
    } else if (confirmNewPassword.value.trim() === "") {
      this.setState({
        confirmNewPassword: {
          value: "",
          error: true,
          errorMessage: "Please enter confirm password",
        },
      });
    } else if (confirmNewPassword.value !== newPassword.value) {
      this.setState({
        confirmNewPassword: {
          value: confirmNewPassword.value,
          error: true,
          errorMessage:
            "The new passwords you entered do not match. Please re-enter.",
        },
      });
    } else {
      let loginData = {
        currentPassword: currentPassword.value,
        newPassword: newPassword.value,
      };
      axios
        .put(Url.editLoginInfo, loginData)
        .then((response) => {
          console.log("error----");
          if (response && response !== undefined) {
            this.setState({
              showEditLoginInfoModal: false,
              error: false,
              errorMessage: "",
            });
          } else {
            this.setState({
              error: true,
              errorMessage: "Current password does not match.",
            });
          }
        })
        .catch((err) => {
          console.log(err, err.response);
          this.setState({
            error: true,
            errorMessage: err.response.data.errors.message,
          });
        });
    }
  };

  showLoginModal = () => {
    console.log("show login modal");
    this.setState((state) => ({
      showEditLoginInfoModal: !state.showEditLoginInfoModal,
      currentPassword: { value: "" },
      newPassword: { value: "" },
      confirmNewPassword: { value: "" },
    }));
  };

  closeLoginModal = () => {
    this.setState((state) => ({
      showEditLoginInfoModal: !state.showEditLoginInfoModal,
      error: false,
    }));
  };

  renderUserSSO = () => {
    let { user } = this.props;
    let ssoLength = user.sso.length;
    return user.sso.reduce(function(acc, curVal, idx) {
      return `${acc}${curVal.provider}${ssoLength != idx + 1 ? ", " : ""}`;
    }, "");
  };

  render() {
    let { email, role, isPasswordChanged } = { ...this.props.user };
    let {
      showEditLoginInfoModal,
      currentPassword,
      newPassword,
      confirmNewPassword,
      error,
      errorMessage,
    } = this.state;
    let alert = null;
    let { user } = this.props;

    console.log("first", currentPassword);

    if (error) {
      alert = (
        <div className="mt10">
          <ErrorMessage message={this.state.errorMessage} />
        </div>
      );
    }
    console.log("showEditLoginInfoModal --- ", showEditLoginInfoModal);
    // <a className="edit-profile-info-link flaticon-edit" onClick={() => {
    //     this.setState((state) =>
    //         ({ showEditLoginInfoModal: !state.showEditLoginInfoModal,
    //            currentPassword: {value: ''},
    //            newPassword: {value: ''},
    //            confirmNewPassword: {value: ''},
    //         }))
    // }}>Edit Login Information</a>

    return (
      <div
        className={`profile_page_about_container wrap-padding-card ${
          isMobile ? "ml-3" : "ml50"
        }`}
      >
        {isPasswordChanged ? (
          <span
            className="profile_page_login_btn"
            onClick={() => this.showLoginModal()}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              viewBox="0 0 16 16"
            >
              <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z" />
              <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115l.094-.319z" />
            </svg>
          </span>
        ) : (
          "null"
        )}

        <Alert color="info" className="profile_page_login_info_msg">
          Only visible to you
        </Alert>

        {isPasswordChanged ? (
          <div className="">
            <div className={`row ${isMobile ? "mt-0" : ""}`}>
              <Col sm={2} className={`${isMobile ? "col-5" : "text-right"}`}>
                <span className="profile-label">Email</span>
              </Col>
              <Col
                sm={9}
                className={`align-self-center ${isMobile && "col-7"}`}
              >
                <span className="profile-value">{email}</span>
              </Col>
            </div>

            <div className="row mt20">
              <Col sm={2} className={`${isMobile ? "col-5" : "text-right"}`}>
                <span className="profile-label">Password</span>
              </Col>
              <Col
                sm={9}
                className={`align-self-center ${isMobile && "col-7"}`}
              >
                <span className="profile-value">********</span>
              </Col>
            </div>
          </div>
        ) : null}

        {this.props.user &&
        this.props.user.sso &&
        this.props.user.sso.length > 0 ? (
          <div className="row mt20">
            <Col sm={2} className={`${isMobile ? "col-5" : "text-right"}`}>
              <span className="profile-label"> SSO login(s)</span>
            </Col>

            <Col
              sm={9}
              className={`align-self-center ${isMobile && "col-7"} pl0`}
            >
              <span className="profile-value">{this.renderUserSSO()}</span>
            </Col>
          </div>
        ) : null}

        {/* <div className="row mt20">
          <Col sm={{ size: 10, offset: 2 }} className="align-self-center">
          <If condition={!isMobile}>
            <a className="edit-profile-info-link flaticon-edit" onClick={() => {
                                    this.setState((state) =>
                                        ({ showEditLoginInfoModal: !state.showEditLoginInfoModal,
                                           currentPassword: {value: ''},
                                           newPassword: {value: ''},
                                           confirmNewPassword: {value: ''},
                                        }))
                                }}>Edit Login Information</a>
          </If>
          </Col>
        </div> */}
        <Modal
          isOpen={showEditLoginInfoModal}
          className="login-info-modal profile_page_login_modal_edit profile-info-modal"
        >
          <ModalHeader
            className="dashboardHeader"
            charCode="X"
            toggle={this.closeLoginModal}
          >
            <div className="dashboardModalTitle">Edit Login Info</div>
          </ModalHeader>
          <ModalBody className="profile-modal-body">
            {/* <Row className="mlmr0">
                           <span className="col-sm-6 col-md-6 profile-modal-heading-txt">Edit Login Information</span>
                        </Row> */}
            {alert}
            <Row className="mlmr0 mt20">
              <Col sm={5} className="profile-modal-label">
                Email
              </Col>
              <Col sm={7}>
                <Input
                  type="text"
                  className="input-custom"
                  value={email}
                  disabled
                />
              </Col>
            </Row>
            <Row className="mlmr0 mt20">
              <Col sm={5} className="profile-modal-label">
                Current Password
              </Col>
              <Col sm={7}>
                <Input
                  type="password"
                  className="input-custom"
                  value={currentPassword.value}
                  onChange={(event) => {
                    this.setState({
                      currentPassword: { value: event.target.value },
                      error: false,
                    });
                  }}
                  invalid={currentPassword.error}
                />
                {currentPassword.error ? (
                  <div className="input-error-msg-field">
                    {currentPassword.errorMessage}
                  </div>
                ) : null}
              </Col>
            </Row>
            <Row className="mlmr0 mt20">
              <Col sm={5} className="profile-modal-label">
                New Password
              </Col>
              <Col sm={7}>
                <Input
                  type="password"
                  className="input-custom"
                  value={newPassword.value}
                  onChange={(event) => {
                    this.setState({
                      newPassword: { value: event.target.value },
                    });
                  }}
                  invalid={newPassword.error}
                />
                {newPassword.error ? (
                  <div className="input-error-msg-field">
                    {newPassword.errorMessage}
                  </div>
                ) : null}
              </Col>
            </Row>
            <Row className="mlmr0 mt20">
              <Col sm={5} className="profile-modal-label">
                Confirm New Password
              </Col>
              <Col sm={7}>
                <Input
                  type="password"
                  className="input-custom"
                  value={confirmNewPassword.value}
                  onChange={(event) => {
                    this.setState({
                      confirmNewPassword: { value: event.target.value },
                    });
                  }}
                  invalid={confirmNewPassword.error}
                />
                {confirmNewPassword.error ? (
                  <div className="input-error-msg-field">
                    {confirmNewPassword.errorMessage}
                  </div>
                ) : null}
              </Col>
            </Row>
            <Row className="mlmr0 mt30 profile_page_login_modal_button_container">
              <Col
                sm={{ size: 4 }}
                md={{ size: 4 }}
                className="profile_page_login_modal_save_btn"
              >
                <Button
                  className="profile-modal-save-btn"
                  onClick={this.handleEditLoginInfo}
                >
                  <span className="profile-modal-save-btn-txt">
                    Save
                    <span className="ml10 flaticon-tick"></span>
                  </span>
                </Button>
              </Col>
              <Col
                sm={{ size: 4 }}
                md={{ size: 4 }}
                className="profile_page_login_modal_cancel_btn"
              >
                <Button
                  className="profile-modal-cancel-btn"
                  onClick={() => this.closeLoginModal()}
                >
                  <span className="profile-modal-cancel-btn-txt">Cancel</span>
                </Button>
              </Col>
            </Row>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default Loading(LoginInfo, axios);
